// clipboard.ts — copy-to-clipboard with a pre-async-API fallback.
//
// navigator.clipboard is undefined outside a secure context (an http://
// staging embed) and can reject when the document isn't focused. The doc-card
// [Copy link] button must not silently do nothing in those cases, so we fall
// back to the selection + execCommand('copy') trick. Deprecated, still
// universally implemented, and the only option without a secure context.

/** Returns true when the text made it to the clipboard. */
export function legacyCopyToClipboard(text: string): boolean {
  try {
    const ta = document.createElement('textarea');
    ta.value = text;
    // Keep it out of view AND out of the layout so nothing scrolls/reflows.
    ta.setAttribute('readonly', '');
    ta.style.position = 'fixed';
    ta.style.top = '-1000px';
    ta.style.opacity = '0';
    document.body.appendChild(ta);
    ta.select();
    const ok = document.execCommand('copy');
    document.body.removeChild(ta);
    return ok;
  } catch {
    return false;
  }
}
